import React, { useState } from 'react';
import { Note } from '../../../types/Note';
import ReactMarkdown from 'react-markdown';
// @ts-ignore
import remarkGfm from 'remark-gfm';
// @ts-ignore
import remarkBreaks from 'remark-breaks';
import './NoteDisplay.css';

interface NoteDisplayProps {
  note: Note | null;
  onEdit?: (note: Note) => void;
  onDelete?: (note: Note) => void;
}

export const NoteDisplay: React.FC<NoteDisplayProps> = ({ note, onEdit, onDelete }) => {
  const [showConfirm, setShowConfirm] = useState(false);

  if (!note) {
    return (
      <div className="note-display note-display--empty">
        <p>Select a note to view its contents</p>
      </div>
    );
  }

  const formatDate = (date: Date) => {
    return new Date(date).toLocaleString('default', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const handleDelete = () => {
    setShowConfirm(true);
  };

  const confirmDelete = () => {
    setShowConfirm(false);
    if (onDelete) onDelete(note);
  };

  const cancelDelete = () => {
    setShowConfirm(false);
  };

  return (
    <div className="note-display">
      <div className="note-display__header">
        <h1 className="note-display__title">{note.title}</h1>
        <div className="note-display__meta">
          <span className="note-display__date">
            Created: {formatDate(note.createdAt)}
          </span>
          <span className="note-display__date">
            Updated: {formatDate(note.updatedAt)}
          </span>
        </div>
        {note.tags.length > 0 && (
          <div className="note-display__tags">
            {note.tags.map((tag) => (
              <span key={tag} className="note-display__tag">
                {tag}
              </span>
            ))}
          </div>
        )}
        <div className="note-display__actions">
          <button className="note-display__edit-btn" onClick={() => onEdit && onEdit(note)}>
            Edit
          </button>
          <button className="note-display__delete-btn" onClick={handleDelete}>
            Delete
          </button>
        </div>
        {showConfirm && (
          <div className="note-display__confirm">
            <p>Are you sure you want to delete this note?</p>
            <button className="note-display__confirm-yes" onClick={confirmDelete}>Yes, delete</button>
            <button className="note-display__confirm-no" onClick={cancelDelete}>Cancel</button>
          </div>
        )}
      </div>
      <div className="note-display__content">
        <ReactMarkdown
          remarkPlugins={[remarkGfm, remarkBreaks]}
          components={{
            a: ({node, ...props}) => (
              <a {...props} target="_blank" rel="noopener noreferrer">{props.children}</a>
            )
          }}
        >
          {note.content}
        </ReactMarkdown>
      </div>
    </div>
  );
}; 